import { createSlice } from '@reduxjs/toolkit'

const getInitialBrand = () => {
    try {
        return localStorage.getItem('admin_active_brand') || 'webtransfer';
    } catch (e) {
        return 'webtransfer';
    }
};

export const headerSlice = createSlice({
    name: 'header',
    initialState: {
        pageTitle: "Home",  // current page title state management
        noOfNotifications : 15,  // no of unread notifications
        newNotificationMessage : "",  // message of notification to be shown
        newNotificationStatus : 1,   // to check the notification type -  success/ error/ info
        activeBrand: getInitialBrand(), // 'webtransfer' | 'kredafi'
    },
    reducers: {
        setPageTitle: (state, action) => {
            state.pageTitle = action.payload.title
        },

        setActiveBrand: (state, action) => {
            state.activeBrand = action.payload;
            try {
                localStorage.setItem('admin_active_brand', action.payload);
            } catch (e) {}
        },

        removeNotificationMessage: (state, action) => {
            state.newNotificationMessage = ""
        },

        showNotification: (state, action) => {
            state.newNotificationMessage = action.payload.message
            state.newNotificationStatus = action.payload.status
        },
    }
})

export const { setPageTitle, setActiveBrand, removeNotificationMessage, showNotification } = headerSlice.actions

export default headerSlice.reducer